import client from "./ApiClient"

const _samlUrl = "/SAML"

const siteSetting = () => {
  return client(`${_samlUrl}/siteSetting`)
}

export { siteSetting }
